// extracted by mini-css-extract-plugin
export default {"overflow":"UserNameModal_overflow__48guJ"};